module.exports = __webpack_public_path__ + "brandon_bld-webfont.bf8d18b6a8f3d52e57f3.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_bld-webfont.woff
// module id = 932
// module chunks = 7